/* eslint-disable vue/multi-word-component-names */
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export default {
    install(app) {
        app.component('Swiper', Swiper);
        app.component('SwiperSlide', SwiperSlide);
    },
};
/* eslint-enable vue/multi-word-component-names */